import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	loading: {
		id: 'trial.dodo.loading',
		defaultMessage: 'Loading...',
		description: 'a loading indicator for the dodo trial page (when the page first loads)',
	},
	loginTitle: {
		id: 'trial.dodo.loginTitle',
		defaultMessage: 'Start Your Free 30-Day Trial',
		description: 'a title for a login component that starts a free trial',
	},
	headline: {
		id: 'trial.dodo.title',
		defaultMessage: 'Dodo Kids is on Calm',
		description: 'Page title describing what Calm is',
	},
	subHeadline: {
		id: 'trial.dodo.subtitle',
		defaultMessage:
			'Calm has joined forces with Dodo Kids to bring you two exclusive new Sleep Stories, “Frankie & Maggie’s Moonlit Hike” and “Arnie’s Nighttime Baths”.',
		description: 'A message inviting members of our partner, the dodo, to try Calm',
	},
	success: {
		id: 'trial.dodo.howToUse.success',
		defaultMessage: 'You have successfully redeemed your 30 day trial',
		description: 'Success message once the trial is redeemed',
	},
	startYourTrial: {
		id: 'trial.hero.signup.startYourTrial',
		defaultMessage: 'Start Your Free Trial',
		description: 'Call to action to start the free trial',
	},
	redeemYourTrial: {
		id: 'trial.hero.login.redeemYourTrial',
		defaultMessage: 'Redeem Your Free Trial',
		description: 'Call to action to redeem the free trial',
	},
	cardRequired: {
		id: 'trial.hero.signup.cardRequired',
		defaultMessage: 'Credit card required.',
		description: 'Call to action to create an account',
	},
	loginCardRequired: {
		id: 'trial.hero.signup.loginCardRequired',
		defaultMessage: 'Log into your Calm account to redeem.',
		description: 'Call to action to log in to your existing account',
	},
	buttonText: {
		id: 'trial.dodo.hero.signup.buttonText',
		defaultMessage: 'Start Free 30-Day Trial',
		description: 'Call to action to start the free trial',
	},
	footerQuestions: {
		id: 'trial.footer.support',
		defaultMessage: 'If you have any questions, contact support <supportlink>here</supportlink>',
		description: 'supportlink is a url to message customer support',
	},
	footerCopyright: {
		id: 'trial.footer.copyright',
		defaultMessage: 'Copyright © 2019 Calm. All rights reserved',
		description: 'Copyright notice',
	},
	loggedInAs: {
		id: 'trial.dodo.loggedInAs',
		defaultMessage: 'Logged in as: {userEmail}',
		description: 'Showing your current user account email (if you are logged in)',
	},
	logout: {
		id: 'trial.dodo.logout',
		defaultMessage: 'Not you? <logoutlink>Log Out</logoutlink>',
		description: 'Log out link',
	},
	alreadySubscribed: {
		id: 'trial.trialFlow.errors.alreadySubscribed',
		defaultMessage:
			"You are already subscribed to Calm, so you can't claim a free trial. You can learn more about your own subscription <herelink>here</herelink>",
		description: "The user already has a subscription, so they can't get a free trial",
	},
	alreadyTrialed: {
		id: 'trial.trialFlow.errors.alreadyTrialed',
		defaultMessage:
			"You have already claimed a trial, so you can't claim another one. You can purchase a Calm subscription for 25% off <herelink>here</herelink>",
		description:
			'Error message for when the user is trying to sign up with a free trial but has already had a free trial',
	},
	giftLoginApplyError: {
		id: 'models.gift.loginApplyError',
		defaultMessage: 'You must be logged in to apply a gift',
		description: 'Error message for when the user is trying to apply a gift without being logged in',
	},
	giftAlreadyAppliedError: {
		id: 'models.gift.alreadyApplied',
		defaultMessage: 'That gift has already been applied',
		description: 'Error message for when the user is trying to apply a gift that has already been applied',
	},
	genericError: {
		id: 'novotel.genericError',
		defaultMessage: 'An unknown error occurred',
		description: "Error message for when something goes wrong with the Novotel page and we don't know what",
	},
	considerNovotel: {
		id: 'trial.ratings.considerNovotel',
		defaultMessage:
			'If you have travel in mind, but haven’t booked your accommodations yet, consider our friends at <novotellink>Novotel</novotellink>.',
		description: 'Marketing message encouraging Novotel for travel accomodations booking',
	},
	magicHotelDescription: {
		id: 'trial.novotel.magicHotelDescription',
		defaultMessage:
			'Award-winning actress Eva Green has recorded a new Sleep Story, in partnership with Novotel. Join Sam and his sister, Annie, as they take an adventure to a most unlikely place, “The Magic Hotel.” Guided by Eva Green’s soothing narration, the listener is invited on a journey of rainbows and butterflies, waltzing flowers and glittering dreams. Get your reservation ready and check into your imagination, where absolutely anything is possible.',
		description: 'A sleep story from Calm in collaboration with Novotel and Eva Green',
	},
	augSlide1Title: {
		id: 'trial.content.slide1.augTitle',
		defaultMessage: 'Back-to-School Sleep Story',
		description: 'Title for slide1 of content section',
	},
	dodoSlide1Description: {
		id: 'dodo.content.slide1.augDescription',
		defaultMessage:
			'Based on popular Dodo Kids animal videos, drift off to sleep as Frankie & Maggie, goat and dog best friends, adventure underneath the stars.',
		description: 'Description for slide1 of content section',
	},
	augSlide2Title: {
		id: 'trial.content.slide2.augTitle',
		defaultMessage: 'Back-to-School Meditations',
		description: 'Title for slide2 of content section',
	},
	dodoSlide2Description: {
		id: 'dodo.content.slide2.augDescription',
		defaultMessage:
			'Join Arnie the armadillo as he searches for a way to make a very special dream come true.',
		description: 'Description for slide2 of content section',
	},
});
